import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { gql } from 'graphql-request';
import graphQLClient from '../client';

export interface FormField {
  field: string;
  value: string | boolean;
}

export interface UmbracoFormData {
  formId: string;
  umbracoPageId: string;
  fields: FormField[];
}

function useSubmitFormMutation(): UseMutationResult<
  any,
  Error,
  UmbracoFormData
> {
  return useMutation<any, Error, UmbracoFormData>({
    mutationFn: async (formData: UmbracoFormData) => {
      // console.log('Submitting form data:', formData);

      // Build the fields array as inline GraphQL
      const fieldsString = formData.fields
        .map(
          (field) =>
            `{ field: "${field.field}", value: "${
              field.value?.toString().replace(/"/g, '\\"') || ''
            }" }`
        )
        .join(', ');

      const mutation = gql`
        mutation {
          form {
            submit(
              formId: "${formData.formId}"
              umbracoPageId: "${formData.umbracoPageId}"
              fields: [${fieldsString}]
            )
          }
        }
      `;

      try {
        const result = await graphQLClient.request(mutation);
        // console.log('Form submission successful:', result);
        return result;
      } catch (error) {
        // console.error('Form submission error:', error);
        throw error;
      }
    },
    onError: (error: Error) => {
      // console.error('Mutation error:', error);
    },
    onSuccess: (data: any) => {
      // console.log('Mutation success:', data);
    },
  });
}

export default useSubmitFormMutation;
